import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

import { routes } from './app.routes';
import { authInterceptor } from './auth/interceptors/auth.interceptor';
import { loaderInterceptor } from './shared/interceptors/loader.interceptor';
import { toastInterceptor } from './shared/interceptors/toast.interceptor';
import {
  UsersApiConfiguration,
  CoreApiConfiguration,
  AnalyticsApiConfiguration,
  CognitoApiConfiguration,
} from '@pagai-fe/api';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([loaderInterceptor, authInterceptor, toastInterceptor])),
    provideAnimations(),
    /**
     * Disable CDK Popover API so overlays use regular z-index instead of the
     * browser top-layer. This allows the global loader (z-999999999) to appear
     * above sheets and dialogs.
     */
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    // API Configurations - Configure rootUrl based on environment
    {
      provide: UsersApiConfiguration,
      useValue: { rootUrl: environment.apiUrl || '' },
    },
    {
      provide: CoreApiConfiguration,
      useValue: { rootUrl: environment.apiUrl || '' },
    },
    {
      provide: AnalyticsApiConfiguration,
      useValue: { rootUrl: environment.apiUrl || '' },
    },
    {
      provide: CognitoApiConfiguration,
      useValue: { rootUrl: environment.apiUrl || '' },
    },
  ],
};
